import React, { useEffect, useState } from "react";
import { apiRequest } from "../../utils/api";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

function NumbersUpload() {
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState();
  const [numbers, setNumbers] = useState([]);

  async function deleteNumber(file) {
    try {
      const res = await apiRequest.delete(
        "/upload-numbers/delete-file/" + file?.file_id
      );
      if (res.data.status == 200) {
        setNumbers([]);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function download(file) {
    try {
      const res = await apiRequest.get(
        "/upload-numbers/single/" + file?.file_id,
        { responseType: "blob" }
      );

      // If the server accidentally sent JSON error, convert and log it
      const contentType = res.headers["content-type"];
      if (contentType && contentType.includes("application/json")) {
        const text = await res.data.text();
        console.error("❌ Server Error:", text);
        return;
      }

      // Extract filename from headers or fallback
      const contentDisposition = res.headers["content-disposition"];
      let fileName = `file-${file?.file_id}.xlsx`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) fileName = match[1];
      }

      // Create download link
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log("✅ File downloaded:", fileName);
    } catch (error) {
      console.error("❌ Download failed:", error);
    }
  }

  async function getFiles() {
    try {
      let res = await apiRequest.get("/upload-numbers/all");
      if (res.data.status == 200) {
        setFiles(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getFiles();
  }, []);

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => <>{index + 1}</>,
    },
    {
      name: "Total Numbers",
      selector: (row) => (
        <>
          <p>{row?.total_numbers}</p>
        </>
      ),
    },
    // {
    //   name: "Total Added",
    //   selector: (row) => (
    //     <>
    //       <p>{row?.added_numbers}</p>
    //     </>
    //   ),
    // },
    // {
    //   name: "Total Removed",
    //   selector: (row) => (
    //     <>
    //       <p>{row?.removed_numbers}</p>
    //     </>
    //   ),
    // },
    {
      name: "File Status",
      selector: (row) => (
        <>
          <p>{row?.file_status}</p>
        </>
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <>
          <button
            disabled={row?.file_status == "deleted"}
            onClick={() => download(row)}
            className="btn btn-success"
          >
            Download
          </button>{" "}
          &nbsp;
          <button
            disabled={row?.file_status == "deleted"}
            onClick={() => deleteNumber(row)}
            className="btn btn-danger"
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  async function uploadFile() {
    if (!file) throw new Error("No file provided");

    const formData = new FormData();
    formData.append("file", file); // key 'file' matches backend

    try {
      const res = await apiRequest.post("/upload-numbers/add", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data.status == 200) {
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Please Wait For Few Moments",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    } catch (error) {
      console.error("Upload failed:", error.response?.data || error.message);
      throw error;
    }
  }

  return (
    <>
      <div>
        <div className="main-content">
          <h2>Upload Numbers File</h2>
          <div className="row">
            <div className="col-md-12 mb-5">
              <Link className="btn btn-danger" to={`/delete-number`}>
                Delete Number
              </Link>
            </div>
            <div className="col-md-12 mb-5">
              <div className="input-group mb-3">
                <input
                  type="file"
                  className="form-control"
                  placeholder="Choose Excel File"
                  aria-label="Choose Excel File"
                  aria-describedby="basic-addon2"
                  onChange={(e) => setFile(e.target.files)}
                />
                <span
                  onClick={uploadFile}
                  className="input-group-text btn btn-primary"
                  style={{ cursor: "pointer" }}
                  id="basic-addon2"
                >
                  Upload
                </span>
              </div>
            </div>

            <div className="col-md-12 mb-5">
              <DataTable columns={columns} data={files} pagination />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NumbersUpload;
